import Glide, { Controls, Breakpoints, Swipe } from "@glidejs/glide/dist/glide.modular.esm";
import { Tab } from "bootstrap/js/dist/tab"; // Add any bootstrap scripts here, they will automatically get bundled in to main.js
import AOS from 'aos';
import MapManager from './map-row.js';
import Calendar from './calendar.js';

Calendar(jQuery);

// Passive event listeners
jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};

/// Touch Screen Menu Navigation
(function ($) {
    $(".nav-primary").each(function () {
        let nav = $(this);
        let topLevelItems = nav.find(">li");
        let topLevelLinks = nav.find(">li>.menu-item-wrapper>a");
        let hasTouch = false;

        function isTouchDevice() {
            return (('ontouchstart' in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0));
        }

        nav.find("ul a").attr("tabindex", -1);

        topLevelLinks.on("click", function (e) {
            if ($(window).width() > 991 && !isTouchDevice())
                return;
            let link = $(this);
            let li = link.parents("li");
            let hasChildMenu = li.find("ul").length > 0;

            if (hasChildMenu) {
                if (!li.hasClass("expanded")) {
                    topLevelItems.removeClass("expanded");
                    li.addClass("expanded");
                    e.preventDefault();
                    e.stopPropagation();
                    $("body").one("click", function (e) {
                        li.removeClass("expanded");
                    });
                    return;
                }
            }
        });
        topLevelItems.on("mouseenter", function () {
            $(this).find("ul a").removeAttr("tabindex");
        }).on("mouseleave", function () {
            $(this).find("ul a").attr("tabindex", -1);
        });
    });
})(jQuery);


/// Carousel (Glide.js) https://glidejs.com/docs/api/
(function ($) {
    $(".glide").each(function () {
        let $elem = $(this);
        $elem.find("a").attr("tabindex", -1);
        let $currentSlideNumber = $elem.find(".current-slide-number");
        let $slideNumbers = $elem.find(".slide-number");
        let config = $elem.data("glide");
        let excludeClones = function () {
            $elem.find(".glide__slide--clone").attr("data-nosnippet", true);
        };
        let glide = new Glide(this, config)
            .on("mount.after", excludeClones).mount({
                Controls,
                Breakpoints,
                Swipe,
            });
        $elem.data("glide-instance", glide);
        if ($currentSlideNumber.length || $slideNumbers.length) {
            glide.on("move.after", function () {
                $slideNumbers.each((index, element) => {
                    if (index === glide.index) {
                        element.classList.add("current");
                    } else {
                        element.classList.remove("current");
                    }
                });
                $currentSlideNumber.text(glide.index + 1);
            });
        }
    });
})(jQuery);

/// Body Tile
(function ($) {
    $(".expandable-section").each(function () {
        let $section = $(this);
        let $trigger = $section.find(".expandable-section__trigger");
        $trigger.click(function (e) {
            e.preventDefault();
            $section.toggleClass("expanded");
        });
    });
})(jQuery);

/// On Page Load More
(function ($) {
    $(".load-more__container").each(function () {
        let $container = $(this);
        let pagesSize = $container.data("page-size");
        if (!pagesSize)
            return;
        let $trigger = $container.parent().find(".load-more__trigger");
        let page = 1;
        const showPage = function () {
            let children = $container.children().filter(":not([disabled])");
            let from = (page - 1) * pagesSize;
            let to = from + pagesSize;
            children
                .filter((index, element) => index >= from && index < to)
                .css("display", "flex")
                .hide()
                .fadeIn();
            if (to >= children.length) {
                $trigger.hide();
            } else {
                $trigger.show();
            }
        };
        $container.on("refresh-list", function () {
            page = 1;
            $container.children().css("display", "");
            showPage();
        });
        $trigger.click(function () {
            page++;
            showPage();
        });
        $container.trigger("refresh-list");
    });
})(jQuery);

/// On Page Event Filtering
(function ($) {
    const CATEGORY_CHANGE_STATE_TYPE = "categoryChange";
    $(".c-upcoming-events__form").each(function () {
        let noDateValue = new Date("1/1/0001 12:00:00 AM").getTime();
        let $filter = $(this);
        let $from = $filter.find("[name='from']");
        let $to = $filter.find("[name='to']");
        let $category = $filter.find("[name='category']");
        const originalCategory = $category.val();
        let $loadMoreContainer = $filter
            .parents(".c-upcoming-events-row")
            .find(".load-more__container");
        let setValidChilden = () => {
            let fromDate = new Date($from.val()).getTime();
            let toDate = new Date($to.val() + " 23:59:59").getTime();
            let selectedCat = $category.val().toLowerCase();
            $loadMoreContainer.children().each(function () {
                let cell = $(this);
                let dateValues = cell.data("date-values").map(v => new Date(v).getTime());
                let categories = cell.data("category");
                console.debug(cell, dateValues, fromDate, toDate, categories);
                let inDateRange = dateValues.length === 0 || dateValues.some(eventDateValue => eventDateValue == noDateValue
                    || (fromDate <= eventDateValue
                        && eventDateValue <= toDate));
                let inCategory = selectedCat == "" || !!categories.find(c => c.toLowerCase() == selectedCat);
                if (inDateRange && inCategory) {
                    cell.removeAttr("disabled");
                } else {
                    cell.attr("disabled", "disabled");
                }
            });
            $loadMoreContainer
                .trigger("refresh-list");
        };
        $filter.on("change", "input,select", function () {
            setValidChilden();
        });
        $category.on("change", function () {
            const state = {
                type: CATEGORY_CHANGE_STATE_TYPE,
                category: $category.val()
            };
            window.history.pushState(state, null, $category.val() ? "?category=" + encodeURIComponent($category.val()) : "");
        });
        setValidChilden();
        window.addEventListener("popstate", function (event) {
            if (!event.state) {
                $category.val(originalCategory);
            } else if (event.state.type === CATEGORY_CHANGE_STATE_TYPE) {
                $category.val(event.state.category);
            }
            setValidChilden();
        });
    });
})(jQuery);

/// Page Scroll Carousel
(function ($) {
    $(".c-page-scroll-carousel-row").each(function () {
        let $row = $(this);
        let trigger = $row.data("trigger");
        let $navItems = $row.find(".c-page-scroll-carousel-row__nav li");
        let $imageItems = $row.find(".c-page-scroll-carousel-row__images li");
        let $currentSlideNumber = $row.find(".current-slide-number");
        let $slideNumbers = $row.find(".slide-number");
        let currentlyActive = $navItems.filter(".active").index();
        let applyCurrentlyActive = function (index, node) {
            $currentSlideNumber.text(currentlyActive + 1);
            $slideNumbers.each((index, element) => {
                if (index === currentlyActive)
                    element.classList.add("current");
                else
                    element.classList.remove("current");
            });
            let $node = $(node);
            if (index == currentlyActive) {
                $node.addClass("active");
            } else {
                $node.removeClass("active");
            }
        };
        let updateScrollToActive = function () {
            let rowTop = $row.position().top;
            let rowHeight = $row.innerHeight();
            let scrollOffset = currentlyActive * Math.floor(rowHeight / $navItems.length);
            $("html,body").animate({ scrollTop: rowTop + scrollOffset });
        };
        let updateCurrentlyActive = function () {
            let rowTop = $row.position().top;
            let rowHeight = $row.innerHeight();
            let rowOffset = $(window).scrollTop() - rowTop;
            if (rowOffset < 0) {
                currentlyActive = 0;
            } else {
                if (rowOffset > rowHeight) {
                    currentlyActive = $navItems.length - 1;
                }
                else {
                    currentlyActive = Math.round($navItems.length * (rowOffset / rowHeight));
                }
            }

            $navItems.each(applyCurrentlyActive);
            $imageItems.each(applyCurrentlyActive);
        };
        if (trigger === "scroll") {
            $navItems.find(".trigger").on("click", function () {
                let index = $(this).parents("li").index();
                currentlyActive = index;
                updateScrollToActive();
            });
        } else if (trigger === "hover") {
            $navItems.find(".trigger").on("mouseover", function () {
                let index = $(this).parents("li").index();
                currentlyActive = index;
                $navItems.each(applyCurrentlyActive);
                $imageItems.each(applyCurrentlyActive);
            });
        }
        $slideNumbers.on("click", function () {
            currentlyActive = $(this).data("index");
            if (trigger === "scroll") {
                updateScrollToActive();
            } else {
                $navItems.each(applyCurrentlyActive);
                $imageItems.each(applyCurrentlyActive);
            }
        });

        $(window).on("scroll", updateCurrentlyActive);
        updateCurrentlyActive();
    });
})(jQuery);

(function ($) {
    const spinners = $(".spin-wrapper");
    if (spinners.length) {
        const raf = window.requestAnimationFrame ?? (fn => setTimeout(fn, 1000 / 60));
        const animateSpinners = () => {
            raf(() => {
                const viewPortSize = $(window).innerHeight();
                const scrollTop = $(window).scrollTop();
                const rotation = (scrollTop % viewPortSize) / viewPortSize * 180;

                spinners.each((index, elem) => {
                    let $parent = $(elem);
                    const speedFactor = $parent.data("scroll-shift") ?? 0;
                    let positionFromTopOfViewPort = $parent.offset().top - scrollTop;
                    let percentShift = positionFromTopOfViewPort / viewPortSize;
                    // calculate the variable top such that the further the $parent is from the bottom of the viewport, the lower the value of top
                    let top = (viewPortSize * -(0.5)) * percentShift * speedFactor;
                    elem.style.setProperty("--rotation-transform", `rotate(${rotation}deg)`);
                    elem.style.setProperty("--spin-offset", `${top}px`);
                });
            });
        };
        $(window).on("scroll", animateSpinners);
        animateSpinners();
        spinners.addClass("initialized");
    }
})(jQuery);

document.addEventListener('DOMContentLoaded', MapManager.initializeMaps);

(function ($) {
    $(".format-vertical .scroll").each(function () {
        const verticalSlider = $(this);
        const slides = verticalSlider.find(".glide__slide");
        let active = 0;
        const updateClasses = function () {
            verticalSlider.find(".current-slide-number").text(active + 1);
            slides.each(function (index, slide) {
                const $s = $(this);
                $s.removeClass("active").removeClass("next").removeClass("previous");
                if (index < active)
                    $s.addClass("previous");
                else if (index == active)
                    $s.addClass("active");
                else if (index > active)
                    $s.addClass("next");
            });
        };
        verticalSlider.on("click", ".glide__arrow--left", function () {
            active--;
            if (active < 0)
                active = slides.length - 1;
            updateClasses();
        });
        verticalSlider.on("click", ".glide__arrow--right", function () {
            active++;
            if (active >= slides.length)
                active = 0;
            updateClasses();
        });

        updateClasses();
        setTimeout(function () {
            verticalSlider.addClass("initialized");
        }, 500);
    });
})(jQuery);

(function ($) {
    // Set aria-label for any links that only have a title tag
    $("[title]:not([aria-label])").attr("aria-label", function () {
        let item = $(this);
        return item.attr("title");
    });
})(jQuery);

(function ($) {
    $(".c-panel-button").each(function () {
        let component = $(this);
        let buttonId = component.data("button-id");
        let panel = component.find(".c-panel-button__content");
        let trigger = component.find(".c-panel-button__trigger");
        let close = component.find(".c-panel-button__close");
        if (localStorage.getItem(buttonId)) {
            panel.show();
        }
        trigger.on('mousedown touchstart', function () {
            if (panel.is(":hidden")) {
                panel.slideDown(() => {
                    localStorage.setItem(buttonId, true);
                    trigger.css("visibility", "hidden");
                });
            }
        });
        close.on('mousedown touchstart', function () {
            localStorage.removeItem(buttonId, true);
            panel.slideUp(() => {
                trigger.css("visibility", "visible");
            });
        });
    });
})(jQuery);

jQuery(function ($) {
    $(".checkboxlist").each(function () {
        let form = $(this);
        let cbs = form.find("[type='checkbox']");
        let all;
        let others = [];
        cbs.each(function (index, cb) {
            if (cb.getAttribute("value") === "ALL")
                all = $(cb);
            else
                others.push(cb);
        });
        if (all && others.length > 0) {
            others = $(others);
            cbs.prop("checked", true);
            others.on("input", function () {
                all.prop('checked', others.filter(":checked").length === others.length);
            });
            all.on("input", function () {
                others.prop("checked", this.checked);
            });
        }
    });
});


/// Initialize Animate on Scroll
AOS.init({
    duration: 2000
});

